import { render, staticRenderFns } from "./notification-ValidationFlowPending.vue?vue&type=template&id=36c6d594&scoped=true"
import script from "./notification-ValidationFlowPending.vue?vue&type=script&lang=js"
export * from "./notification-ValidationFlowPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c6d594",
  null
  
)

export default component.exports